// Supabase service for HKDSE Original Texts
// Replaces hkdseOriginalTexts.js imports

import { querySupabase } from '../supabaseClient';

/**
 * Get original text by text ID
 */
export const getOriginalTextById = async (textId) => {
  try {
    const records = await querySupabase('chi_hkdseoriginaltext', { text_id: textId }, {
      limit: 1
    });
    
    if (!records || records.length === 0) return null;
    
    const record = records[0];
    return {
      id: record.text_id,
      title: record.title,
      author: record.author,
      dynasty: record.dynasty,
      category: record.category,
      type: record.type,
      originalText: record.original_text,
      modernTranslation: record.modern_translation
    };
  } catch (error) {
    console.error('Error fetching original text:', error);
    return null;
  }
};

/**
 * Get all original texts
 */
export const getAllOriginalTexts = async () => {
  try {
    const records = await querySupabase('chi_hkdseoriginaltext', {}, {
      order_by: 'text_id',
      order_direction: 'asc'
    });
    
    if (!records || records.length === 0) return [];
    
    // Group by text_id (since each text might have multiple records)
    const textMap = {};
    records.forEach(record => {
      if (!textMap[record.text_id]) {
        textMap[record.text_id] = {
          id: record.text_id,
          title: record.title,
          author: record.author,
          dynasty: record.dynasty,
          category: record.category,
          type: record.type,
          originalText: record.original_text,
          modernTranslation: record.modern_translation
        };
      }
    });
    
    return Object.values(textMap);
  } catch (error) {
    console.error('Error fetching all original texts:', error);
    return [];
  }
};

